//import jQuery from "jquery/dist/jquery";

const geolocation = (function (window) {
	"use-strict";
	/**
	 * Creates GeoLocation on a form element with nested in "geolocation-block" class.
	 */

	if (
		typeof jQuery == "undefined"
	) {
		console.info(
			"'jQuery' script is not available. Skipping loading of \"geolocation.js\" script."
		);
		return;
	}

	window.SznGeoCode = function () {
		var obj = this;

		function getAddressLabels($geoLocFormElement) {
			var labels = [];

			var fields = $geoLocFormElement.find(".geoloc-src");

			for (var i = 0; i < fields.length; i++) {
				var $field = jQuery(fields[i]);

				if ($field.length) {
					var fieldID = $field.attr("id");

					var $label = jQuery('label[for="' + fieldID + '"]');

					if ($label.length) {
						labels.push($label.text());
					}
				}
			}

			return labels.join("\n - ");
		}

		function getAddressQuery($geoLocFormElement) {
			var fieldValues = "";

			var fields = $geoLocFormElement.find(".geoloc-src");

			for (var i = 0; i < fields.length; i++) {
				var $field = jQuery(fields[i]);

				if ($field.length) {
					fieldValues += $field.val() + " ";
				}
			}

			return fieldValues;
		}

		function geoCode(query, labels, $inputLat, $inputLng) {
			labels = labels || "patřičná pole formuláře";

			const url = new URL('https://api.mapy.cz/v1/geocode');

			url.searchParams.set('lang', 'cs');
			url.searchParams.set('apikey', 'OuaGqu2t-IYjREBH0tmrYKttlqavBi-j2xL15NP0CZE');
			url.searchParams.set('query', query);
			url.searchParams.set('limit', '15');
		
			const response = fetch(url.toString(), {
				mode: 'cors',
			})
			.then(response => {
					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}
					return response.json();
				})
			.then(data => {
				if (data && Array.isArray(data.items)
					&& data.items.length > 0) {
					const firstItem = data.items[0];
					if (firstItem.position && firstItem.position.lat && firstItem.position.lon) {

						$inputLat.val(firstItem.position.lat);
						$inputLng.val(firstItem.position.lon);
						return;
					}
				}
				alert(
					"Geolokace selhala. Zkontrolujte prosím:\n - " + labels
				);
			})
			.catch(error => {
				console.error('Error:', error);
			});			
		}

		obj.init = function init(geoLocBlockClass) {
			geoLocBlockClass = geoLocBlockClass || "geoloc-block";

			var $geoLocFormElement = jQuery("." + geoLocBlockClass);

			if ($geoLocFormElement.length) {
				$geoLocFormElement.each((index, element) => {
					var $currentgeoLoc = jQuery(element);
					var $form = $currentgeoLoc.closest("form");

					if (!$form.length) {
						return;
					}

					var $inputLat = $currentgeoLoc.find(".geoloc-lat");
					var $inputLng = $currentgeoLoc.find(".geoloc-lon");
					var $button = $currentgeoLoc.find(".geoloc-btn");

					$button.on("click", function (e) {
						e.preventDefault();
						var query = getAddressQuery($currentgeoLoc);
						var labels = getAddressLabels($currentgeoLoc);

						if (query) {
							geoCode(query, labels, $inputLat, $inputLng);
						}
					});
				});
			}
		};

		return obj;
	};

	new SznGeoCode().init();
})(window);

export default geolocation;
